import clsx from "clsx";
import { ButtonHTMLAttributes, forwardRef } from "react";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean;
  variant?: "primary" | "secondary" | "tertiary" | "ghost" | "ghostDark" | undefined;
};

const primaryStyles = clsx(
  "atlas-text-white atlas-bg-info-8 atlas-ring-info-3",
  "hover:atlas-bg-info-9",
  "active:atlas-bg-info-10",
  "focus:atlas-ring-2",
  "disabled:atlas-bg-info-2 disabled:atlas-text-info-5"
);
const secondaryStyles = clsx(
  "atlas-text-info-11 atlas-bg-info-1 atlas-ring-info-7 atlas-ring-2",
  "hover:atlas-bg-info-2 hover:atlas-ring-info-8",
  "active:atlas-bg-info-3 active:atlas-ring-info-9",
  "focus:atlas-ring-info-3",
  "disabled:atlas-bg-white disabled:atlas-ring-info-2 disabled:atlas-text-info-3"
);
const tertiaryStyles = clsx(
  "atlas-text-info-11 atlas-bg-neutral-1 atlas-ring-info-3",
  "hover:atlas-bg-neutral-2",
  "active:atlas-bg-neutral-3",
  "focus:atlas-ring-2",
  "disabled:atlas-bg-white disabled:atlas-text-info-4"
);
const ghostStyles = clsx(
  "atlas-bg-transparent atlas-ring-info-3/20",
  "hover:atlas-bg-info-1/20",
  "active:atlas-bg-info-2/40",
  "focus:atlas-ring-2",
  "disabled:atlas-text-info-4/40"
);

const ghostDarkStyles = clsx(
  "atlas-bg-transparent atlas-ring-info-3",
  "hover:atlas-bg-info-9",
  "active:atlas-bg-info-8",
  "focus:atlas-ring-2"
  // "disabled:atlas-text-info-4"
);

const variants = {
  primary: primaryStyles,
  secondary: secondaryStyles,
  tertiary: tertiaryStyles,
  ghost: ghostStyles,
  ghostDark: ghostDarkStyles,
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = "primary", className, ...rest }, ref) => {
    return (
      <button
        className={clsx(
          "atlas-inline-flex atlas-items-center atlas-justify-center atlas-relative atlas-isolate atlas-shadow-sm atlas-gap-x-2 atlas-px-3 atlas-py-2 atlas-rounded-lg atlas-text-sm ring-inset",
          variants[variant],
          className
        )}
        ref={ref}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";
